<template>
  <section class="feature-carousel" aria-label="StoReel feature carousel">
    <div class="feature-track">
      <img
        v-for="(slide, index) in duplicatedSlides"
        :key="`${slide}-${index}`"
        class="feature-card"
        :src="slide"
        alt=""
        loading="lazy"
        decoding="async"
        draggable="false"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  slides: string[]
}>()

const duplicatedSlides = computed(() => [...props.slides, ...props.slides])
</script>

<style scoped>
.feature-carousel {
  position: absolute;
  z-index: 1;
  top: var(--feature-top);
  left: 50%;
  width: 100vw;
  height: var(--feature-height);
  overflow: hidden;
  background: #000;
  contain: layout paint style;
  transform: translateX(-50%);
}

.feature-carousel::before,
.feature-carousel::after {
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  width: var(--feature-fade-width);
  content: '';
  pointer-events: none;
}

.feature-carousel::before {
  left: 0;
  background: linear-gradient(90deg, #000 0%, rgb(0 0 0 / 0%) 100%);
}

.feature-carousel::after {
  right: 0;
  background: linear-gradient(270deg, #000 0%, rgb(0 0 0 / 0%) 100%);
}

.feature-track {
  display: flex;
  width: max-content;
  gap: var(--feature-gap);
  transform: translate3d(var(--feature-start), 0, 0);
  animation: featureMarquee 28s linear infinite;
  will-change: transform;
}

.feature-card {
  display: block;
  width: var(--feature-card-width);
  height: 100%;
  flex: 0 0 auto;
  object-fit: cover;
  user-select: none;
  pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
  .feature-track {
    animation: none;
  }
}

@keyframes featureMarquee {
  from {
    transform: translate3d(var(--feature-start), 0, 0);
  }

  to {
    transform: translate3d(var(--feature-end), 0, 0);
  }
}
</style>
